import { Route, Routes } from "react-router-dom";
import WorkflowModule from ".";

const WorkflowRoute = () => (
  <Routes>
    <Route path="/*" element={<WorkflowModule />} />
  </Routes>
);

export default WorkflowRoute;
